export default __webpack_public_path__ + "static/media/500_error.f884f7c8.svg";